// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/report/ReportMobileTable.css
// module id = 2023
// module chunks = 0